<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    title="批量更换审批人"
    :visible.sync="show"
    width="70%"
    :destroy-on-close="true"
    :before-close="handleDialogClose"
    @open="handleopen"
  >
    <div>
      <div>
        <div>注意事项：</div>
        <p>· 当审批配置节点下仅有1个审批人时，只能操作替换，不能删除；</p>
        <p>
          ·
          由于钉钉的限制，更换审批人只能对后续新发起的审批生效，已在审批中的需要在钉钉系统中进行人工转交。
        </p>
      </div>
      <el-form
        :model="form"
        label-width="120px"
        size="small"
        :inline="true"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="审批流" prop="bizTypeList">
          <QS-select
            v-model="form.bizTypeList"
            :optionData="bizTypeListOptions"
            @change="handleBizTypeList"
            :optionConfig="{
              valueKey: 'bizType',
              labelKey: 'bizName',
            }"
            filterable
            multiple
            clearable
            placeholder="请选择客户"
          />
        </el-form-item>
        <el-form-item label="部门" prop="deptIdList">
          <DeptSelect
            v-model="form.deptIdList"
            filterable
            multiple
            @change="handleDeptIdList"
          />
        </el-form-item>
        <el-form-item label="钉钉组织" prop="organizationId">
          <el-select
            v-model="form.organizationId"
            placeholder="请选择钉钉组织"
            clearable
            filterable
            :disabled="form.deptIdList.length === 0"
            @change="handleOrganizationList"
          >
            <el-option
              v-for="item in organizationIdOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="原审批人" prop="sourceApproverId">
          <el-select
            v-model="form.sourceApproverId"
            placeholder="请选择原审批人"
            filterable
            clearable
            :disabled="!form.organizationId"
            @change="handlesourceApproverId"
          >
            <el-option
              v-for="item in approverListOptions"
              :key="item.id"
              :label="item.adminName"
              :value="item.adminUid"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="操作" prop="replaceType">
          <el-radio-group
            v-model="form.replaceType"
            @change="handlereplaceType"
          >
            <el-radio :label="1">从审批节点中删除</el-radio>
            <el-radio :label="0">替换审批人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="替换审批人为"
          v-if="form.replaceType === 0"
          prop="targetApproverId"
        >
          <el-select
            v-model="form.targetApproverId"
            placeholder="请选择替换审批人"
            filterable
          >
            <el-option
              v-for="item in targetApproverIdOptions"
              :key="item.id"
              :label="item.adminName"
              :disabled="item.adminUid === form.sourceApproverId"
              :value="item.adminUid"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleDialogClose">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  getBizTypeList, // 获取审批类型
  getOrganizationList,
  getApproverList,
  submitApprover,
} from '@/api/domain/approvals'
import DeptSelect from '@/components/DeptSelect'
import { fetchAuditUser } from '@/api/approvalApi'

export default {
  name: 'BatchReplaceApprovaler',
  components: {
    DeptSelect,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      organizationName: '',
      submitLoading: false,
      form: {
        bizTypeList: [],
        deptIdList: [],
        organizationId: '',
        replaceType: '',
        sourceApproverId: '',
        targetApproverId: '',
      },
      bizTypeListOptions: [],
      organizationIdOptions: [],
      approverListOptions: [],
      targetApproverIdOptions: [],
      rules: {
        bizTypeList: [{ required: true, message: '请选择审批流' }],
        deptIdList: [{ required: true, message: '请选择部门' }],
        organizationId: [{ required: true, message: '请选择钉钉组织' }],
        sourceApproverId: [{ required: true, message: '请选择原审批人' }],
        replaceType: [{ required: true, message: '请选择替换审批人' }],
      },
    }
  },
  methods: {
    handleBizTypeList() {
      this.getOrganizationList()
    },
    handleopen() {
      this.submitLoading = false
      this.getBizTypeList()
    },
    async handleSubmit() {
      if (this.submitLoading) return
      this.submitLoading = true
      try {
        const status = await this.$refs.ruleForm.validate()
        if (!status) {
          this.submitLoading = false
          return
        }
        const { code } = await submitApprover({ ...this.form })
        if (code !== 1) {
          this.submitLoading = false
          return
        }
        this.$message.success('批量更换成功')
        this.handleDialogClose()
      } catch {
        this.submitLoading = false
      }
    },
    handleDialogClose() {
      this.form = {
        bizTypeList: [],
        deptIdList: [],
        organizationId: '',
        replaceType: '',
        sourceApproverId: '',
        targetApproverId: '',
      }
      this.organizationName = ''
      this.bizTypeListOptions = []
      this.organizationIdOptions = []
      this.targetApproverIdOptions = []
      this.approverListOptions = []
      this.$emit('update:show', false)
    },
    async getBizTypeList() {
      const params = {
        type: 'approveType',
        open: 1,
      }
      const { data, code } = await getBizTypeList(params)
      if (code === 1) {
        this.bizTypeListOptions = [...data]
        this.form.bizTypeList = data.map((item) => item.bizType)
      }
    },
    handleDeptIdList() {
      this.form.organizationId = ''
      this.form.sourceApproverId = ''
      this.organizationIdOptions = []
      this.approverListOptions = []
      this.getOrganizationList()
    },
    async getOrganizationList() {
      if (!this.form.bizTypeList || this.form.bizTypeList.length <= 0) return
      if (!this.form.deptIdList || this.form.deptIdList.length <= 0) {
        return
      }
      const params = {
        bizTypeList: this.form.bizTypeList,
        deptIdList: this.form.deptIdList,
      }
      const { data, code } = await getOrganizationList(params)
      if (code !== 1) return
      this.organizationIdOptions = [...data]
    },
    handleOrganizationList() {
      this.getApproverList()
    },
    async getApproverList() {
      if (!this.form.bizTypeList || this.form.bizTypeList.length <= 0) return
      if (!this.form.deptIdList || this.form.deptIdList.length <= 0) {
        return
      }
      if (!this.form.organizationId) return
      const params = {
        bizTypeList: this.form.bizTypeList,
        deptIdList: this.form.deptIdList,
        organizationId: this.form.organizationId,
      }
      const { data, code } = await getApproverList(params)
      if (code === 1) {
        this.approverListOptions = [...data]
      }
    },
    handlesourceApproverId() {
      this.sourceApproverId = null
      this.handlereplaceType()
    },
    handlereplaceType() {
      if (this.form.replaceType === 0) {
        this.fetchAuditUser()
      }
    },
    async fetchAuditUser() {
      if (!this.form.organizationId) return
      const { data, code } = await fetchAuditUser({
        organizationId: this.form.organizationId,
      })
      if (code === 1) {
        this.targetApproverIdOptions = [...data]
      }
    },
  },
}
</script>
